import { forwardRef, ReactNode } from 'react';

import MuiStepper, { StepperProps as MuiStepperProps } from '@mui/material/Stepper';
import { styled } from '@mui/material/styles';

import { PaperProps } from '../Paper';
import stepIconClasses from '../StepIcon/stepIconClasses';

export * from '@mui/material/Stepper';

export type StepperVariant = 'numbers' | 'symbols' /*| 'visual'*/;

interface StepperOwnerState {
  variant: StepperVariant;
}

// FIXME(FE-871): get rid of the "| keyof PaperProps" part
export interface StepperProps extends Omit<MuiStepperProps, 'variant' | keyof PaperProps> {
  variant?: StepperOwnerState['variant'];
  sx?: MuiStepperProps['sx'];
  children?: ReactNode;
}

const StyledMuiStepper = styled(MuiStepper)<MuiStepperProps & { ownerState: StepperOwnerState }>(
  ({ ownerState: { variant }, theme }) => ({
    // hide all 'symbols'-related elements
    ...(variant === 'numbers' && {
      [`& .${stepIconClasses.checkmark}, & .${stepIconClasses.dot}`]: {
        display: 'none',
      },
      [`&& .${stepIconClasses.root}`]: {
        [`&.${stepIconClasses.completed}`]: {
          backgroundColor: 'transparent',
        },
      },
    }),
    // hide all 'numbers'-related
    ...(variant === 'symbols' && {
      [`& .${stepIconClasses.text}`]: {
        display: 'none',
      },
      [`&& .${stepIconClasses.root}`]: {
        [`&.${stepIconClasses.completed}`]: {
          color: `${theme.palette.common.white}`,
        },
      },
    }),
  })
);

const Stepper = forwardRef<HTMLDivElement, StepperProps>(({ variant = 'numbers', ...props }, ref) => (
  <StyledMuiStepper ownerState={{ variant }} {...props} ref={ref} />
));

Stepper.displayName = 'Stepper';

export default Stepper;
